define('SuiteCommerce.OrderStatus.OrderFinder.Order.Model', ['Utils', 'Backbone'], function define(Utils, Backbone) {
	'use strict';
	return Backbone.Model.extend({
		urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('Assets/Services/OrderFinder.Service.ss'), true),
		initialize: function initialize() {
			this.validation = {};
		},
		defaults: function defineDefaultsValues() {
			return {
				ordernumber: '',
				verificationfield: '',
				details: {},
			};
		},
		addValidationRuleForProperty: function addValidationRuleForProperty(field, rule) {
			if (!Object.prototype.hasOwnProperty.call(this.validation, field)) {
				this.validation[field] = [];
			}
			this.validation[field].push(rule);
		},
	});
});
